import { render, staticRenderFns } from "./LineDetails.vue?vue&type=template&id=70d9e73c&"
import script from "./LineDetails.vue?vue&type=script&lang=js&"
export * from "./LineDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSeguroEmpateBadge: require('/var/web/bet777.es/components/elements/seguro-empate-badge.vue').default,EventTime: require('/var/web/bet777.es/components/event_time.vue').default})
